import { httpGet } from '@pressreader/services';

import { IIssueCalendarInfoDto } from '../types/issue.calendar';

function getIssueCalendarInfo(cid: string) {
    return httpGet<IIssueCalendarInfoDto>('calendar', { cid });
}

export { getIssueCalendarInfo };
